import script from "./RegisterInfoIdentificationNumberDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterInfoIdentificationNumberDialog.vue?vue&type=script&setup=true&lang=js"

import "./RegisterInfoIdentificationNumberDialog.vue?vue&type=style&index=0&id=73e9b4c8&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e9b4c8"]])

export default __exports__